import { migratedLabels, excludedDomainList } from '../migrated-labels';

export default (labelKey) =>
	migratedLabels.some((label) => label.labelKey === labelKey) &&
	process.env.NODE_ENV !== 'development' &&
	!excludedDomainList.some(
		(excludedDomain) => excludedDomain === document.location.host
	);
